// Single source of truth for the backend API base URL. Override with
// REACT_APP_API_URL at build time; defaults to the local dev backend.
export const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';
